import React from 'react';

export const EventInfoSection = ({ showHeading = true }) => {
  const scheduleBlocks = [
    {
      title: 'Registration & Pack Collection',
      date: 'Saturday 25th July 2026',
      rows: [
        { event: 'Optional registration for all distances', open: '3:00 PM', close: '6:00 PM', location: 'Camden Town Hall' },
      ],
    },
    {
      title: 'Half Marathon (21.1KM)',
      date: 'Sunday 26th July 2026',
      rows: [
        { event: 'Bib Collection', open: '5:15 AM', close: '6:30 AM', location: 'Registration Marquee' },
        { event: 'Race Briefing', open: '6:40 AM', close: '6:50 AM', location: 'Start Line' },
        { event: 'Race Start', open: '7:00 AM', close: '11:30 AM', location: 'Camden Main Street Loop', highlight: true },
        { event: 'Presentation', open: '1:00 PM', close: '-', location: 'Finish Village' },
      ],
    },
    {
      title: '10KM Run',
      date: 'Sunday 26th July 2026',
      rows: [
        { event: 'Bib Collection', open: '6:20 AM', close: '8:00 AM', location: 'Registration Marquee' },
        { event: 'Race Briefing', open: '8:10 AM', close: '8:20 AM', location: 'Start Line' },
        { event: 'Race Start', open: '8:30 AM', close: '10:30 AM', location: 'Camden Main Street Loop', highlight: true },
        { event: 'Presentation', open: '1:00 PM', close: '-', location: 'Finish Village' },
      ],
    },
    {
      title: '5KM Run',
      date: 'Sunday 26th July 2026',
      rows: [
        { event: 'Bib Collection', open: '6:45 AM', close: '8:30 AM', location: 'Registration Marquee' },
        { event: 'Race Briefing', open: '8:40 AM', close: '8:50 AM', location: 'Start Line' },
        { event: 'Race Start', open: '9:00 AM', close: '10:15 AM', location: 'Camden Main Street Loop', highlight: true },
        { event: 'Presentation', open: '1:00 PM', close: '-', location: 'Finish Village' },
      ],
    },
    {
      title: '2KM Fun Run',
      date: 'Sunday 26th July 2026',
      rows: [
        { event: 'Bib Collection', open: '9:15 AM', close: '11:00 AM', location: 'Registration Marquee' },
        { event: 'Race Briefing', open: '11:05 AM', close: '11:15 AM', location: 'Start Line' },
        { event: 'Race Start', open: '11:30 AM', close: '12:30 PM', location: 'Camden Main Street Loop', highlight: true },
      ],
    },
  ];

  return (
    <section id="event-info" className="section-full bg-muted py-16 sm:py-20 lg:py-24 border-t border-border">
      <div className="container-wide">
        {showHeading && (
          <div className="text-center mb-12 sm:mb-14">
            <p className="text-sm uppercase tracking-widest font-bold text-muted-foreground mb-4">Event Info</p>
            <h2 className="text-4xl sm:text-5xl md:text-6xl font-black mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              EVENT SCHEDULE
            </h2>
            <p className="text-muted-foreground max-w-3xl mx-auto text-sm sm:text-base">
              Schedule overview for race weekend on Sunday 26th July 2026. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Times may be adjusted closer to event day.
            </p>
          </div>
        )}

        <div className="space-y-8 sm:space-y-10">
          {scheduleBlocks.map((block) => (
            <div key={block.title} className="bg-white border border-border shadow-sm overflow-hidden">
              <div className="px-4 sm:px-6 py-4 border-b border-border">
                <h3 className="text-2xl sm:text-3xl font-black text-foreground mb-1" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                  {block.title}
                </h3>
                <p className="text-sm uppercase tracking-wide font-bold text-muted-foreground">{block.date}</p>
              </div>

              <div className="overflow-x-auto">
                <table className="w-full min-w-[720px]">
                  <thead>
                    <tr className="bg-foreground text-white text-xs uppercase tracking-wider">
                      <th className="px-4 py-3 text-left">Event</th>
                      <th className="px-4 py-3 text-left">Open</th>
                      <th className="px-4 py-3 text-left">Close</th>
                      <th className="px-4 py-3 text-left">Location</th>
                    </tr>
                  </thead>
                  <tbody>
                    {block.rows.map((row, rowIndex) => (
                      <tr key={`${block.title}-${row.event}-${rowIndex}`} className="border-t border-border">
                        <td className={`px-4 py-3 font-semibold ${row.highlight ? 'bg-primary/30 text-foreground' : 'bg-primary/15 text-foreground'}`}>
                          {row.event}
                        </td>
                        <td className="px-4 py-3 text-sm text-muted-foreground">{row.open}</td>
                        <td className="px-4 py-3 text-sm text-muted-foreground">{row.close}</td>
                        <td className="px-4 py-3 text-sm text-muted-foreground">{row.location}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EventInfoSection;
